<template>
  <v-data-table
      :headers="headers"
      :items="factors"
      sort-by="factor_en"
      class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>{{ $t("Factors") }}</v-toolbar-title>
        <v-divider
            class="mx-4"
            inset
            vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">{{ $t("New Item") }}</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.factor_en" label="Factor EN"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.factor_de" label="Factor DE"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
      >
        edit
      </v-icon>
      <v-icon
          small
          @click="deleteItem(item)"
      >
        delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <!--            <v-btn color="primary" @click="getDataItems">Reset</v-btn>-->
      <p style="text-align: center;">Loading... Please wait</p>
    </template>
  </v-data-table>
</template>

<script>
import {i18n} from "@/main.js";
import {apiService} from "../../common/apiService";

export default {
  name: "Factors",
  data: () => ({
    dialog: false,
    headers: [
      {
        text: 'id',
        value: 'id',
      },
      {
        text: i18n.t("Factor EN"),
        value: 'factor_en',
      },
      {
        text: i18n.t("Factor DE"),
        value: 'factor_de',
      },
      {text: 'Actions', value: 'action', sortable: false},
    ],
    factors: [],
    userid: 0,
    editedIndex: -1,
    editedItem: {
      factor_en: '',
      factor_de: '',
    },
    defaultItem: {
      factor_en: '',
      factor_de: '',
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? this.$i18n.t('New Item') : this.$i18n.t('Edit Item')
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
  },

  created() {
    this.getDataItems()
    this.getUserId()
  },

  methods: {

    getUserId() {
      let endpoint = "en/api/rest-auth/user/";
      apiService(endpoint).then((response) => {
        // eslint-disable-next-line no-console
        console.log(response.data.pk)
        this.userid = response.data.pk;
      })
    },

    getDataItems() {
      let endpoint = "en/api/factors/";
      apiService(endpoint).then((response) => {
        this.factors = response.data;
      })
    },

    editItem(item) {
      this.editedIndex = this.factors.indexOf(item)
      this.editedItem = Object.assign({}, item)

      this.dialog = true
    }
    ,

    deleteItem(item) {
      const index = this.factors.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.factors.splice(index, 1)

      let endpoint = "en/api/factors/" + item.id + "/";
      apiService(endpoint, 'delete').then((response) => {
        // eslint-disable-next-line no-console
        console.log(response)
        this.getDataItems()
      })

    }
    ,

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }
    ,

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.factors[this.editedIndex], this.editedItem)

        let endpoint = "en/api/factors/" + this.editedItem.id + "/";
        apiService(endpoint, 'patch', {
          factor: this.editedItem.factor_en,
          factor_en: this.editedItem.factor_en,
          factor_de: this.editedItem.factor_de,
        }).then((response) => {
          // eslint-disable-next-line no-console
          console.log(response)
          this.getDataItems()
        })


      } else {
        this.factors.push(this.editedItem)

        let endpoint = "en/api/factors/";
        apiService(endpoint, 'post', {
          factor: this.editedItem.factor_en,
          factor_en: this.editedItem.factor_en,
          factor_de: this.editedItem.factor_de,
          owner: this.userid,
        }).then((response) => {
          // eslint-disable-next-line no-console
          console.log(response)
          this.getDataItems()
        })

      }
      this.close()
    }
    ,
  },
}
</script>

<style scoped>

</style>